import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { COMP_INFO } from '../../config/siteConfig';
import { DARK_LOGO_URL as companyLogo } from '../../config/siteConfig';
// Add this import at the top (after companyLogo import)
import bgImage from '../../assets/images/bg.jpg';

const Signup = () => {
    const [formData, setFormData] = useState({
        title: "Mr.",
        firstName: "", lastName: "",
        mobile: "", email: "", whatsapp: "",
        agencyName: "", agencyAddress: "",
        country: "India", state: "", city: "", pincode: "",
        panNo: "", panCardHolder: "",
        panCardFile: null, hasGST: false,
        logoFile: null, salesRef: "", remark: "",
        userId: "", password: "", confirmPassword: ""
    });

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form data:", formData);
    };

    const inputStyle = {
        border: "1.5px solid #e8ecf4", borderLeft: "none",
        borderRadius: "0 8px 8px 0", background: "white",
        fontSize: "13px", color: "#1e3a6e"
    };
    const prefixStyle = {
        background: "#eef0ff", border: "1.5px solid #e8ecf4",
        borderRight: "none", borderRadius: "8px 0 0 8px", minWidth: "36px"
    };
    const iconColor = "#2d4f8e";

    const SectionHeader = ({ icon, label, color = "#2d4f8e", bg = "#eef0ff" }) => (
        <div className="d-flex align-items-center gap-2 mb-3">
            <div style={{ width: 28, height: 28, borderRadius: 8, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <i className={`bi ${icon}`} style={{ color, fontSize: 13 }}></i>
            </div>
            <span style={{ fontSize: "12px", fontWeight: 700, color, textTransform: "uppercase", letterSpacing: "0.7px" }}>{label}</span>
        </div>
    );

    return (
        <div className="auth_login" style={{
            position: "fixed",
            inset: 0,
            overflowY: "auto",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            padding: "40px 20px",
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>

            {/* Centered form card */}
            <div style={{
                width: "100%", maxWidth: "720px",
                background: "rgba(255,255,255,0.96)",
                backdropFilter: "blur(24px)",
                borderRadius: "20px",
                padding: "40px 36px",
                boxShadow: "0 20px 60px rgba(15,37,87,0.15)",
                marginBottom: "40px"
            }}>

                {/* Header: logo + title + back to login */}
                <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                            <img src={companyLogo} alt="logo" style={{ height: "28px", objectFit: "contain", flexShrink: 0 }} />
                            <h5 style={{ fontWeight: 800, color: "#1e3a6e", marginBottom: 0, fontSize: "16px" }}>Create Account</h5>
                        </div>
                        <Link to="/login" style={{
                            display: "flex", alignItems: "center", gap: 5,
                            fontSize: "12px", fontWeight: 700, color: "#2d4f8e",
                            textDecoration: "none", background: "#eef0ff",
                            padding: "5px 12px", borderRadius: "20px", flexShrink: 0
                        }}>
                            <i className="bi bi-arrow-left" style={{ fontSize: 11 }}></i>
                            Back to Login
                        </Link>
                    </div>
                    <p style={{ fontSize: "12px", color: "#a0aec0", marginBottom: 0, marginTop: "6px", paddingLeft: "2px" }}>
                        Register your agency on {COMP_INFO.NAME}
                    </p>
                </div>

                <form onSubmit={handleSubmit}>

                    {/* ── Personal Details ── */}
                    <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                        <SectionHeader icon="bi-person-fill" label="Personal Details" />
                        <div className="row g-2">

                            <div className="col-4 col-md-2">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Title</label>
                                <select name="title" value={formData.title} onChange={handleChange} className="form-select form-select-sm"
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white", color: "#1e3a6e" }}>
                                    {["Mr.", "Mrs.", "Ms.", "Dr."].map(t => <option key={t}>{t}</option>)}
                                </select>
                            </div>

                            <div className="col-8 col-md-5">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>First Name *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-person" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-5">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Last Name *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-person" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Mobile No. *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={{ ...prefixStyle, minWidth: "auto", padding: "0 8px", fontSize: "12px", fontWeight: 700, color: iconColor }}>+91</span>
                                    <input type="tel" className="form-control form-control-sm" name="mobile" placeholder="Mobile No." value={formData.mobile} onChange={handleChange} required style={inputStyle} />
                                </div>
                                <div style={{ fontSize: "10px", color: "#a0aec0", marginTop: 3, paddingLeft: 2 }}>This number will be your User ID</div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Email *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-envelope" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="email" className="form-control form-control-sm" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>WhatsApp No. *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-whatsapp" style={{ color: "#25d366", fontSize: 12 }}></i></span>
                                    <input type="tel" className="form-control form-control-sm" name="whatsapp" placeholder="WhatsApp No." value={formData.whatsapp} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* ── Agency Details ── */}
                    <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                        <SectionHeader icon="bi-building" label="Agency Details" />
                        <div className="row g-2">

                            <div className="col-12 col-md-6">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Agency Name *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-briefcase" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="agencyName" placeholder="Agency Name" value={formData.agencyName} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Agency Address *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-geo-alt" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="agencyAddress" placeholder="Agency Address" value={formData.agencyAddress} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-6 col-md-3">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Country</label>
                                <select name="country" value={formData.country} onChange={handleChange} className="form-select form-select-sm"
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white", color: "#1e3a6e" }}>
                                    <option>India</option>
                                </select>
                            </div>

                            <div className="col-6 col-md-3">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>State</label>
                                <select name="state" value={formData.state} onChange={handleChange} className="form-select form-select-sm"
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white", color: "#1e3a6e" }}>
                                    <option value="">-- Select State --</option>
                                </select>
                            </div>

                            <div className="col-6 col-md-3">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>City</label>
                                <select name="city" value={formData.city} onChange={handleChange} className="form-select form-select-sm"
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white", color: "#1e3a6e" }}>
                                    <option value="">-- Select City --</option>
                                </select>
                            </div>

                            <div className="col-6 col-md-3">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Pin Code</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-pin-map" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="pincode" placeholder="Pin Code" value={formData.pincode} onChange={handleChange} style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>PAN No. *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-credit-card" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="panNo" placeholder="PAN No." value={formData.panNo} onChange={handleChange} required style={{ ...inputStyle, textTransform: "uppercase" }} />
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>PAN Card Holder Name *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-person-vcard" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="panCardHolder" placeholder="Name of PAN Card Holder" value={formData.panCardHolder} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>PAN Card Image *</label>
                                <input type="file" className="form-control form-control-sm" name="panCardFile" accept=".jpg,.jpeg" onChange={handleChange}
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white" }} />
                                <div style={{ fontSize: "10px", color: "#a0aec0", marginTop: 3 }}>Attach PAN Card image — must be in JPG format</div>
                            </div>

                            <div className="col-12">
                                <div className="d-flex align-items-center gap-2 p-2 rounded-3" style={{ background: "white", border: "1.5px solid #eef0f8" }}>
                                    <input type="checkbox" className="form-check-input mt-0" id="hasGST" name="hasGST" checked={formData.hasGST} onChange={handleChange}
                                        style={{ width: "18px", height: "18px", cursor: "pointer", accentColor: "#2d4f8e" }} />
                                    <label htmlFor="hasGST" style={{ fontSize: "13px", fontWeight: 600, color: "#4b5563", cursor: "pointer", marginBottom: 0 }}>
                                        Do you have GST?
                                    </label>
                                </div>
                            </div>

                            <div className="col-12 col-md-7">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Agency Logo</label>
                                <input type="file" className="form-control form-control-sm" name="logoFile" accept=".png" onChange={handleChange}
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white" }} />
                                <div style={{ fontSize: "10px", color: "#a0aec0", marginTop: 3 }}>PNG format, size 90×70 pixels</div>
                            </div>

                            <div className="col-12 col-md-5">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Sales Reference</label>
                                <select name="salesRef" value={formData.salesRef} onChange={handleChange} className="form-select form-select-sm"
                                    style={{ border: "1.5px solid #e8ecf4", borderRadius: "8px", fontSize: "13px", background: "white", color: "#1e3a6e" }}>
                                    <option value="">Select Sales Ref.</option>
                                </select>
                            </div>

                            <div className="col-12">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Remark</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={{ ...prefixStyle, alignItems: "flex-start", paddingTop: "7px" }}><i className="bi bi-chat-text" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <textarea className="form-control form-control-sm" name="remark" placeholder="Remark (Optional)" value={formData.remark} onChange={handleChange} rows={2}
                                        style={{ ...inputStyle, resize: "none" }} />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* ── Authentication Information ── */}
                    <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                        <SectionHeader icon="bi-shield-lock-fill" label="Authentication Information" />
                        <div className="row g-2">

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>User ID *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-person-badge" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="text" className="form-control form-control-sm" name="userId" placeholder="User ID" value={formData.userId} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Password *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-lock" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="password" className="form-control form-control-sm" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: 700, color: "#a0aec0", textTransform: "uppercase", letterSpacing: "0.6px" }}>Confirm Password *</label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" style={prefixStyle}><i className="bi bi-lock-fill" style={{ color: iconColor, fontSize: 12 }}></i></span>
                                    <input type="password" className="form-control form-control-sm" name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required style={inputStyle} />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Submit */}
                    <button type="submit" className="w-100 btn fw-bold text-white d-flex align-items-center justify-content-center gap-2"
                        style={{
                            background: "linear-gradient(135deg, #2d4f8e 0%, #5b84c4 100%)",
                            borderRadius: "10px", border: "none", height: "46px", fontSize: "14px",
                            boxShadow: "0 4px 16px rgba(45,79,142,0.3)", letterSpacing: "0.5px"
                        }}>
                        <i className="bi bi-person-check-fill"></i> Create Account
                    </button>

                    <div className="text-center mt-3 mb-1">
                        <span style={{ fontSize: "13px", color: "#a0aec0" }}>Already have an account? </span>
                        <Link to="/login" style={{ fontSize: "13px", fontWeight: 700, color: "#2d4f8e", textDecoration: "none" }}>Login Now</Link>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default Signup;